import type { LabelMap, StatusMap } from '../../../types/common';

/** Record types in the "Module" filter. */
export const ACTIVITY_ENTITIES: LabelMap = {
  customer: 'Customers',
  quotation: 'Quotations',
  job: 'Service jobs',
  invoice: 'Invoices',
  payment: 'Payments',
  expense: 'Expenses',
  purchase: 'Purchases',
  vendor: 'Suppliers',
  item: 'Materials & work rates',
  template: 'Quote templates',
  master: 'Master data',
  attendance: 'Attendance',
  payslip: 'Salary slips',
  user: 'Team',
  settings: 'Settings',
  account: 'Sign-ins',
};

/** Action badge: [label, tone]. Anything else shows as "Changed". */
export const ACTIVITY_ACTIONS: StatusMap = {
  create: ['Created', 'green'],
  update: ['Edited', 'blue'],
  delete: ['Deleted', 'red'],
  cancel: ['Cancelled', 'red'],
  reverse: ['Reversed', 'red'],
  finalize: ['Finalized', 'sky'],
  status: ['Status', 'sky'],
  convert: ['Converted', 'sky'],
  'create-invoice': ['Invoiced', 'sky'],
  share: ['Shared', 'neutral'],
  unshare: ['Unshared', 'neutral'],
  login: ['Sign in', 'grey'],
  logout: ['Sign out', 'grey'],
  'change-password': ['Password', 'yellow'],
  'reset-password': ['Password', 'yellow'],
  save: ['Saved', 'blue'],
  'adjust-stock': ['Stock', 'yellow'],
};

/** Tabs above the table (sent as ?group=). */
export const ACTIVITY_TABS = [
  { value: '', label: 'All' },
  { value: 'created', label: 'Created' },
  { value: 'changed', label: 'Changed' },
  { value: 'deleted', label: 'Deleted & cancelled' },
  { value: 'signins', label: 'Sign-ins' },
];
